export const styles = {
  fields: 'gap-sm md:gap-md',
  field: 'flex-1 max-w-[6.4rem]',
  fieldWrapper: 'justify-center',
  input: 'min-w-[1.6rem] font-F37Bold text-center text-md',
};
